import { render, staticRenderFns } from "./AIChatIndex.vue?vue&type=template&id=47d149e6&scoped=true&"
import script from "./AIChatIndex.vue?vue&type=script&lang=js&"
export * from "./AIChatIndex.vue?vue&type=script&lang=js&"
import style0 from "./AIChatIndex.vue?vue&type=style&index=0&id=47d149e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d149e6",
  null
  
)

export default component.exports